import { ConfigOption } from '@ngx-formly/core';
import { MobileOpenStockChooserComponent } from './submodules/mobile-warehouse/mobile-open-stock-chooser/mobile-open-stock-chooser.component';

export const MOBILE_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-mobile-open-stock-chooser', component: MobileOpenStockChooserComponent, wrappers: ['simple-title'], },
]
